/**
 * Passthrough strategy - returns original file for server-side processing
 * Always available as the final fallback
 */

import type {
  AudioExtractionStrategy,
  ProgressCallback,
  ExtractionStrategy,
} from '../types';

export class PassthroughStrategy implements AudioExtractionStrategy {
  readonly name: ExtractionStrategy = 'passthrough';

  async checkSupport(): Promise<boolean> {
    // Always available
    return true;
  }

  canHandle(_file: File): boolean {
    // Can handle any file
    return true;
  }

  async extract(file: File, onProgress?: ProgressCallback): Promise<File> {
    // Simply return the original file - server will handle extraction
    onProgress?.({
      stage: 'converting',
      progress: 1,
      strategy: 'passthrough',
    });
    return file;
  }
}
